import React from 'react'

export default function ModalFileBtn() {
  return (
    <button
      data-toggle="modal"
      data-target="#exampleModalLong"
      className="btn btn-primary mr-3 w-100"
    >
      <i className="fa fa-folder-open mr-2" />
      <span>File Pendukung</span>
    </button>
  )
}
